import React from 'react';
import CareersComponent from '../components/Careers/Careers';

/**
 * CareersPage - Careers page wrapper
 */
export default function CareersPage() {
  return <CareersComponent />;
}
